import path from 'path'

export default defineNuxtRouteMiddleware((to, from) => {
  // ako ne postoji slika, video, audio ili skripta - ne reqestati nista s [...all].vue
  if (process.server && (isMedia(to.fullPath) || to.fullPath.includes('.well-known'))) return abortNavigation()
  if (process.client) {
    document.documentElement.classList.remove('isMenuOpen');
    document.documentElement.classList.remove('isOverflow');
    const menuOpen = useState('menuOpen');
    if (menuOpen.value) menuOpen.value = false;
  }
})

function isMedia(filePath) {
  const extensions = new Set([
    '3dv',
    'ai',
    'amf',
    'art',
    'ase',
    'awg',
    'blp',
    'bmp',
    'bw',
    'cd5',
    'cdr',
    'cgm',
    'cit',
    'cmx',
    'cpt',
    'cr2',
    'cur',
    'cut',
    'dds',
    'dib',
    'djvu',
    'dxf',
    'e2d',
    'ecw',
    'egt',
    'emf',
    'eps',
    'exif',
    'fs',
    'gbr',
    'gif',
    'gpl',
    'grf',
    'hdp',
    'heic',
    'heif',
    'icns',
    'ico',
    'iff',
    'int',
    'inta',
    'jfif',
    'jng',
    'jp2',
    'jpeg',
    'jpg',
    'jps',
    'jxr',
    'lbm',
    'liff',
    'max',
    'miff',
    'mng',
    'msp',
    'nef',
    'nitf',
    'nrrd',
    'odg',
    'ota',
    'pam',
    'pbm',
    'pc1',
    'pc2',
    'pc3',
    'pcf',
    'pct',
    'pcx',
    'pdd',
    'pdn',
    'pgf',
    'pgm',
    'PI1',
    'PI2',
    'PI3',
    'pict',
    'png',
    'pnm',
    'pns',
    'ppm',
    'psb',
    'psd',
    'psp',
    'px',
    'pxm',
    'pxr',
    'qfx',
    'ras',
    'raw',
    'rgb',
    'rgba',
    'rle',
    'sct',
    'sgi',
    'sid',
    'stl',
    'sun',
    'svg',
    'sxd',
    'tga',
    'tif',
    'tiff',
    'v2d',
    'vnd',
    'vrml',
    'vtf',
    'wdp',
    'webp',
    'wmf',
    'x3d',
    'xar',
    'xbm',
    'xcf',
    'xpm',
    'mp3',
    'mp4',
    'mov',
    'js'
  ])

  return extensions.has(path.extname(filePath).slice(1).toLowerCase())
}
